import { ekDomain, ROUTES, WORDPRESS_PATH } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import LogoRental from '@/assets/images/logo-icon-rental.svg';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { isPathEk } from '@/utils/routes';
import SheetMenuEU from './SheetMenuEU';
import { cn } from '@/utils/utils';
import { URL_CONFIG } from '@/configs/environment';

import './style.scss';

export default observer(function NavbarEU() {
    // hooks
    const { t } = useTranslation();
    const { pathname } = useLocation();

    // const
    const isEk = isPathEk(pathname);

    // store
    const {
        authStore: { tokenGas, tokenEk, logout },
        modalStore: { showAlertModal, hideModal }
    } = useStore();

    const handleLogout = () => {
        const idModal = 'confirm-logout-modal';
        showAlertModal({
            id: idModal,
            size: 'sm',
            content: t('messages.confirm_logout'),
            isConfirmModal: true,
            saveButton: t('button.sign_out'),
            onSave: () => {
                hideModal(idModal);
                logout();
            }
        });
    };

    return (
        <div className='header-wrapper-inner h-[min(60px,15vw)] point-940:h-20 px-[min(50px,4vw)]  py-[min(10px,3vw)] grid grid-cols-[min(225px,20vw),auto] gap-[min(20px,5vw)] items-center'>
            <div className='logo point-940:w-auto w-[min(175px,45vw)]'>
                <Link to={`${isEk ? `${URL_CONFIG.APP.url}/${ekDomain}` : `${URL_CONFIG.DOMAIN_WORDPRESS.url}`}`} className='main-logo_wrap'>
                    <span className='icon'><img src={LogoRental} alt='' /></span>
                    <svg className='w-full fill-black block max-w-full' viewBox='0 0 158.286 28.754' aria-label='ベストBikeレンタル' role='img'>
                        <use href={isEk ? '#kick-logo' : '#main-logo'}></use>
                    </svg>
                </Link>
            </div>
            <div
                className={cn(
                    'grid point-940:grid-cols-[auto,min(320px,25vw)] justify-end items-center gap-[min(40px,4vw)] font-semibold'
                )}
            >
                <MenuEUList />
                <>
                    {
                        isEk && (
                            <>
                                <div className='hidden point-940:grid grid-cols-2 head-button-set js-slide-wall relative overflow-hidden border-2 border-primaryWeb rounded-[10px] group'>
                                    <Link
                                        to={!tokenEk ? `/${ekDomain}${ROUTES.signup.href}` : `/${ekDomain}${ROUTES.myAccount.href}`}
                                        className='join js-join-btn flex items-center justify-center h-[60px] bg-clip-text text-transparent bg-[length:200%_100%] bg-[position:100%_center] group-hover:bg-[position:left_center]'
                                    >
                                        新規会員登録
                                    </Link>
                                    {
                                        !tokenEk ?
                                            (
                                                <Link
                                                    to={`/${ekDomain}${ROUTES.signin.href}`}
                                                    className='login js-login-btn flex items-center justify-center h-[60px] bg-clip-text text-transparent bg-[length:200%_100%] bg-[position:left_center]  group-hover:bg-[position:100%_center]'
                                                >
                                                    会員ログイン
                                                </Link>
                                            ) :
                                            (
                                                <div
                                                    className='login js-login-btn flex items-center justify-center h-[60px] bg-clip-text text-transparent bg-[length:200%_100%] bg-[position:left_center]  group-hover:bg-[position:100%_center]'
                                                    onClick={() => {
                                                        handleLogout();
                                                        document.body.style.pointerEvents = 'auto';
                                                    }}
                                                >
                                                    {t('words_title.sign_out')}
                                                </div>
                                            )
                                    }
                                </div>
                            </>
                        )
                    }
                    {
                        !isEk && (
                            <>
                                <div className='hidden point-940:grid grid-cols-2 head-button-set js-slide-wall relative overflow-hidden border-2 border-primaryWeb rounded-[10px] group'>
                                    <Link
                                        to={!tokenGas ? `${ROUTES.signup.href}` : `${ROUTES.myAccount.href}`}
                                        className='join js-join-btn flex items-center justify-center h-[60px] bg-clip-text text-transparent bg-[length:200%_100%] bg-[position:100%_center] group-hover:bg-[position:left_center]'
                                    >
                                        {
                                            !tokenGas ? '新規会員登録' : t('words_title.my_page')
                                        }

                                    </Link>
                                    {
                                        !tokenGas ?
                                            (
                                                <Link
                                                    to={ROUTES.signin.href}
                                                    className='login js-login-btn flex items-center justify-center h-[60px] bg-clip-text text-transparent bg-[length:200%_100%] bg-[position:left_center]  group-hover:bg-[position:100%_center]'
                                                >
                                                    会員ログイン
                                                </Link>
                                            ) :
                                            (
                                                <div
                                                    className='login js-login-btn flex items-center justify-center h-[60px] bg-clip-text text-transparent bg-[length:200%_100%] bg-[position:left_center]  group-hover:bg-[position:100%_center]'
                                                    onClick={() => {
                                                        handleLogout();
                                                        document.body.style.pointerEvents = 'auto';
                                                    }}
                                                >
                                                    {t('words_title.sign_out')}
                                                </div>
                                            )
                                    }

                                </div>
                            </>
                        )
                    }
                    <SheetMenuEU />
                </>
            </div>

        </div>
    );
});

const MenuEUList = observer(() => {
    // hooks
    const { t } = useTranslation();
    const { pathname } = useLocation();

    // const
    const isEk = isPathEk(pathname);

    return (
        <>
            <ul className='header-link-nav hidden point-940:flex items-center gap-[min(20px,3vw)] justify-end'>
                <li>
                    <Link
                        to={`${isEk ? `/${ekDomain}` : `${URL_CONFIG.DOMAIN_WORDPRESS.url}/${WORDPRESS_PATH.howTo.href}`}`}
                        className='menu-item-text'
                    >
                        {t('words_title.how_to_use')}
                    </Link>
                </li>
                <li>
                    <Link
                        to={
                            isEk ? `/${ekDomain}/${ROUTES.priceList.hrefEK}` : `${ROUTES.priceList.href}`
                        }
                        className='menu-item-text'
                    >
                        {t('words_title.price_list')}
                    </Link>
                </li>
                <li>
                    <Link
                        to='https://bestbike-special.com/tachigoke/index.html'
                        className='menu-item-text'
                    >
                        {t('words_title.standing_moss_security_system')}
                    </Link>
                </li>
                <li>
                    <Link
                        to={`${isEk ? `/${ekDomain}` : `${URL_CONFIG.DOMAIN_WORDPRESS.url}/${WORDPRESS_PATH.contact.href}`}`}
                        className='menu-item-text'
                    >
                        {t('words_title.inquiry')}
                    </Link>
                </li>
            </ul>
        </>
    );
});
